import {ActionButton} from "../../designSystem/components/ActionButton";
import React from "react";
import {useNavigate} from "react-router-dom";

export const GoBackNavigationIconButton = () => {
  const navigate = useNavigate();
  const onClickGoPrevious = () => navigate(-1);

  return (
    <ActionButton
      variant="ghost"
      onClick={onClickGoPrevious}
      iconName="fa-chevron-left"
      size="xl"
    />
  )
}